import React from "react";

/**
 * Minimalist SVG sparkline showing per-day counts for the last N days.
 *
 * props:
 *  - items: array of objects
 *  - dateField: string key holding an ISO timestamp (default "created_at")
 *  - days: number of days to include (default 7)
 *  - label: string shown under the chart (default "ultimi 7 giorni")
 *  - color: bar color (default amber)
 */
export default function Sparkline({ items = [], dateField = "created_at", days = 7,
                                     label = "ultimi 7 giorni", color = "#F59E0B" }) {
  const now = new Date();
  const buckets = Array.from({ length: days }, (_, i) => {
    const d = new Date(now); d.setDate(d.getDate() - (days - 1 - i));
    return { key: d.toISOString().slice(0, 10), count: 0,
             label: d.toLocaleDateString("it-IT", { weekday: "short", day: "numeric" }) };
  });
  items.forEach((it) => {
    const t = (it && it[dateField] || "").slice(0, 10);
    const bucket = buckets.find((b) => b.key === t);
    if (bucket) bucket.count += 1;
  });
  const max = Math.max(1, ...buckets.map((b) => b.count));
  const W = 140, H = 32, barW = W / days;

  return (
    <div className="inline-flex items-center gap-2" data-testid="sparkline">
      <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} className="shrink-0">
        {buckets.map((b, i) => {
          const h = (b.count / max) * (H - 4);
          return (
            <g key={b.key}>
              <rect
                x={i * barW + 1}
                y={H - h}
                width={barW - 2}
                height={Math.max(h, 1)}
                fill={color}
                opacity={b.count === 0 ? 0.2 : 0.9}
                rx={1}
              >
                <title>{b.label}: {b.count}</title>
              </rect>
            </g>
          );
        })}
      </svg>
      <span className="text-[10px] text-zinc-500">{label}</span>
    </div>
  );
}
